import AboutUs from "@/views/about-us.vue";
import BookmarkList from "@/views/admin/bookmark-list.vue";
import ChangePassword from "@/views/admin/change-password.vue";
import CheckoutPage from "@/views/admin/checkout-page.vue";
import CreateAccount from "@/views/admin/create-account.vue";
import DashboardPage from "@/views/admin/dashboard-page.vue";
import MyProfile from "@/views/admin/my-profile.vue";
import MyProperty from "@/views/admin/my-property.vue";
import PaymentPage from "@/views/admin/payment-page.vue";
import SubmitPropertyDashboard from "@/views/admin/submit-property-dashboard.vue";
import AgencyPage from "@/views/agencie/agency-page.vue";
import PageAgencies from "@/views/agencie/page-agencies.vue";
import AddAgent from "@/views/agent/add-agent.vue";
import AgentPage from "@/views/agent/agent-page.vue";
import EditAgent from "@/views/agent/edit-agent.vue";
import PageAgents from "@/views/agent/page-agents.vue";
import ComponentPage from "@/views/component-page.vue";
import ContactPage from "@/views/contact-page.vue";
import ErrorPage from "@/views/error-page.vue";
import FaqPage from "@/views/faq-page.vue";
import IndexTen from "@/views/index/index-ten.vue";
import PricingPage from "@/views/pricing-page.vue";
import ClassicalProperty from "@/views/property/classical-property.vue";
import CompareProperty from "@/views/property/compare-property.vue";
import GridLayoutWithMap from "@/views/property/grid-layout-with-map.vue";
import GridLayoutWithSidebar from "@/views/property/grid-layout-with-sidebar.vue";
import GridPage from "@/views/property/grid-page.vue";
import ListLayoutNew3 from "@/views/property/list-layout-new-3.vue";
import SingleProperty1 from "@/views/property/single-property-1.vue";
import SubmitProperty from "@/views/property/submit-property.vue";
import ServicesOffered from "@/views/services-page.vue";
import PrivacyDetails from "@/views/privacy-details.vue";
import TradeServices from "@/views/services/trade-services.vue";
import TradeRequest from "@/views/services/trade-request.vue";
import { createRouter, createWebHistory } from "vue-router";
import store from '@/store/store'; // Ensure store is imported
import Login from '@/views/LoginPage.vue';
import PropertyAdmin from '@/views/admin/PropertyAdmin.vue';

const routes = [
  {
    path: "/",
    component: IndexTen,
    meta: {
      title: "Rental Properties in Greater Moncton | Apartments & Houses for Rent | 99 Properties",
      description: "Find rental properties in Moncton including apartments, houses, condos, and basement units. Updated listings, verified landlords, and easy property search across Moncton, Dieppe, and Riverview.",
    },
  },
  { path: "/agents", component: PageAgents },
  { path: "/agent-page", component: AgentPage },
  { path: "/agent-page/:id", component: AgentPage },
  { path: "/add-agent", component: AddAgent },
  { path: "/edit-agent", component: EditAgent },
  { path: "/agencies", component: PageAgencies },
  { path: "/agency-page", component: AgencyPage },
  { path: "/agency-page/:id", component: AgencyPage },
  { path: "/compare-property", component: CompareProperty },
  {
    path: "/submit-property",
    name: "submit-property",
    component: SubmitProperty,
    meta: {
      title: "Submit a Property | 99 Properties Moncton",
      description: "List your rental property on 99Properties.ca. Reach verified tenants across Greater Moncton, Dieppe, and Riverview.",
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/propertyadmin',
    name: 'propertyadmin',
    component: PropertyAdmin,
    meta: { requiresAuth: true },
  },
  {
    path: "/about-us",
    component: AboutUs,
    meta: {
      title: "About Us | 99 Property Management Moncton",
      description: "Learn about 99 Property Management — your trusted partner for rental properties and trade services in Greater Moncton, New Brunswick.",
    },
  },
  { path: "/component", component: ComponentPage },
  {
    path: "/pricing",
    component: PricingPage,
    meta: {
      title: "Pricing | 99 Properties Moncton",
      description: "Transparent pricing for property listing and management services in Greater Moncton.",
    },
  },
  {
    path: "/faq",
    component: FaqPage,
    meta: {
      title: "FAQ | 99 Properties Moncton",
      description: "Frequently asked questions about renting, listing, and trade services at 99Properties.ca.",
    },
  },
  { path: "/404", component: ErrorPage },
  {
    path: "/contact",
    component: ContactPage,
    meta: {
      title: "Contact Us | 99 Properties Moncton",
      description: "Get in touch with 99 Property Management. Call, email, or send a message to our Moncton team.",
    },
  },
  { path: "/dashboard", component: DashboardPage },
  { path: "/payment", component: PaymentPage },
  { path: "/my-profile", component: MyProfile },
  { path: "/create-account", component: CreateAccount },
  { path: "/checkout", component: CheckoutPage },
  { path: "/my-property", component: MyProperty },
  { path: "/bookmark-list", component: BookmarkList },
  { path: "/change-password", component: ChangePassword },
  { path: "/submit-property-dashboard", component: SubmitPropertyDashboard },
  {
    path: "/list-layout-new-3",
    component: ListLayoutNew3,
    meta: {
      title: "Browse All Rental Properties in Moncton | 99 Properties",
      description: "Browse the full list of rental properties in Greater Moncton — apartments, houses, condos, and more. Filter by neighbourhood and price.",
    },
  },
  { path: "/grid-layout-with-sidebar", component: GridLayoutWithSidebar },
  { path: "/grid-layout-with-map", component: GridLayoutWithMap },
  { path: "/grid", component: GridPage },
  { path: "/classical-property", component: ClassicalProperty },
  { path: "/single-property-1", component: SingleProperty1 },
  { path: "/single-property-1/:id", component: SingleProperty1 },
  {
    path: "/services-offered",
    component: ServicesOffered,
    meta: {
      title: "Our Offerings | 99 Property Management Moncton",
      description: "Discover the property management and tenant services offered by 99 Properties in Greater Moncton.",
    },
  },
  {
    path: "/privacy-details",
    component: PrivacyDetails,
    meta: {
      title: "Privacy Policy | 99 Properties",
      description: "Read our privacy policy to understand how 99Properties.ca collects and uses your information.",
    },
  },
  {
    path: "/trade-services",
    component: TradeServices,
    meta: {
      title: "Property Trade Services in Moncton | Electrical, Plumbing, HVAC & More | 99 Properties",
      description: "Book licensed trade professionals in Moncton — electrical, plumbing, HVAC, lawn care, cleaning, painting, duct cleaning, and driveway seal. Fast, reliable, and vetted.",
    },
  },
  {
    path: "/trade-request",
    component: TradeRequest,
    meta: {
      title: "Request a Trade Service | 99 Properties Moncton",
      description: "Submit a service request for electrical, plumbing, HVAC, cleaning, or any trade service in Greater Moncton. Our team will get back to you soon.",
    },
  },
];



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // --- THIS IS THE KEY PART ---
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Go back to saved scroll position (for browser back/forward)
    } else if (to.hash) {
      // If there's a hash, scroll to the element with that ID
      return {
        el: to.hash, // The element to scroll to (e.g., '#my-section')
        behavior: 'smooth', // Optional: for smooth scrolling animation
        top: +100, // Offset the scroll position by 10px above the element
      };
    } else {
      // Otherwise, scroll to the top of the page
      return { top: 0, behavior: 'smooth' };
    }
  }
});

// Update <title> and meta description on every route change
router.afterEach((to) => {
  const defaultTitle = "Rental Properties in Greater Moncton | 99 Properties";
  const defaultDesc =
    "Find rental properties in Moncton including apartments, houses, condos, and basement units. Updated listings and easy search on 99Properties.ca.";

  document.title = to.meta?.title || defaultTitle;

  const descTag = document.querySelector('meta[name="description"]');
  if (descTag) descTag.setAttribute("content", to.meta?.description || defaultDesc);

  const canonical = document.getElementById("canonical-url");
  if (canonical) canonical.setAttribute("href", `https://99properties.ca${to.path}`);
});

// --- CORRECTED NAVIGATION GUARD ---
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // This function decides where to navigate
  const proceed = () => {
    const isAuthenticated = store.getters['auth/isAuthenticated'];
    if (requiresAuth && !isAuthenticated) {
      // If route requires auth and user is not logged in, redirect to login
      next({ name: 'login' });
    } else {
      // Otherwise, allow navigation
      next();
    }
  };

  // Check if auth state is ready.
  if (store.getters['auth/authIsReady']) {
    // If ready, proceed immediately.
    proceed();
  } else {
    // If not ready, watch for it to become true, then proceed.
    // The `once: true` option is crucial to prevent this from running multiple times.
    store.watch(
      (state) => state.auth.authIsReady,
      (isReady) => {
        if (isReady) {
          proceed();
        }
      },
      { once: true }
    );
  }
});

export default router;
